import { CardList } from 'components/cardList';
import { useGetItemListFromModularContent } from 'hooks/useGetItemListFromModularContent';
import { CasinoCatalogResponseApi } from 'lib/api/casinoCatalogResponseApi';
import { CMS_CASINO_MODEL_API_KEY, CONSOLE_GIOCHI_CASINO_MODEL_API_KEY } from 'lib/datoCms/constants';
import { DatoCmsConsoleGiochiItemList, DatoCmsItemList } from 'lib/datoCms/types';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import { GamesSkillGameDto } from 'types/swagger';
import { CardTypes } from '../cards/types';
export type CasinoArchiveProps<T extends CardTypes> = {
  games?: Array<GamesSkillGameDto> | CasinoCatalogResponseApi;
  casinoListModularContent?: Array<DatoCmsItemList | DatoCmsConsoleGiochiItemList>;
  children?: React.ReactNode;
};
export const CasinoArchive = ({ games, casinoListModularContent, children }: CasinoArchiveProps<CardTypes>) => {
  const [casinoUpdate, setCasinoUpdated] = useState<Array<GamesSkillGameDto> | []>([]);
  const dynamicRoute = useRouter().asPath;

  const { listName, middlewareIdList } = useGetItemListFromModularContent({
    itemModularContent: casinoListModularContent,
    consoleGiochiModelApiKey: CONSOLE_GIOCHI_CASINO_MODEL_API_KEY,
    cmsModelApiKey: CMS_CASINO_MODEL_API_KEY,
  });

  const matchCmsCasino = useCallback(
    async (idList: string[]) => {
      try {
        const cmsGame = idList
          .map((id: string) => {
            const gamesOfCatalog = games as CasinoCatalogResponseApi;
            if (games) {
              const filtered = gamesOfCatalog.games.filter((game: GamesSkillGameDto) => {
                return game.id === id;
              });
              return filtered[0];
            }
            return;
          })
          .map((e) => e!);
        setCasinoUpdated(cmsGame!);
      } catch (error) {
        console.error('error:', error);
      }
    },
    [games]
  );
  useEffect(() => {
    if (
      casinoListModularContent &&
      casinoListModularContent[0]._modelApiKey === CMS_CASINO_MODEL_API_KEY &&
      middlewareIdList
    ) {
      matchCmsCasino(middlewareIdList);
    }
    if (listName && games) {
      const casinoCatalog = games as CasinoCatalogResponseApi;
      if (!!casinoCatalog.games.length) {
        const middlewareGame = casinoCatalog.games?.filter((game) => {
          const catalog = games as unknown as CasinoCatalogResponseApi;
          return catalog[listName as keyof typeof catalog]?.some((element) => {
            return element === game.id;
          });
        });
        setCasinoUpdated(middlewareGame);
      }
    }
    if (!casinoListModularContent) {
      const gamesOfCatalog = games as unknown as Array<GamesSkillGameDto>;
      setCasinoUpdated(gamesOfCatalog);
    }
  }, [dynamicRoute]);
  return (
    <CardList typeOfItem="casino" filteredItems={casinoUpdate}>
      {children}
    </CardList>
  );
};
